import { SelectSearchField } from 'components'
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import UsersApiV2 from 'api/v2/admins/users-api-v2'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool,
  onSelect : PropTypes.func,
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true,
  onSelect : (selectedUser) => {},
}

/**
 * Search field to select user by email, name, or phone.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {function} onSelect - (selectedUser) => void
 */
const UserSelectSearchField = ({
  name,
  label,
  required,
  onSelect,
  ...props
}) => {
  const { setFieldError, setFieldTouched } = useFormikContext()

  const [searchUsers, setSearchUsers] = useState([])
  const [isSearchLoading, setSearchLoading] = useState(false)
  const userSearchTimeout = useRef(null)

  const getUsers = (keyword) => {
    setSearchLoading(true)

    const additionalFilters = {
      q: keyword,
    }

    UsersApiV2.get({ additionalFilters })
      .then((response) => {
        setSearchUsers(response.data.users)
      })
      .catch(() => {
        setFieldError(name, 'Searching for User failed.')
        setFieldTouched(name, true, false)
      })
      .finally(() => setSearchLoading(false))
  }

  const normalizePhoneCode = (phoneCode) => {
    const value = (phoneCode || '').toString().trim()

    if (!value) return ''
    return value.startsWith('+') ? value : `+${value}`
  }

  const formatPhoneDisplay = (option) => {
    const phone = (option?.phone || '').toString().trim()
    const phoneCode = normalizePhoneCode(option?.phone_code)

    if (!phone) return '(No Phone Number)'
    if (!phoneCode) return `(${phone})`

    return `(${phoneCode} ${phone})`
  }

  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{option.email || '-'}</span>
      <span className='mr-3'>-</span>
      <span className='mr-3'>{option.name || '-'}</span>
      <span className='mr-3'>{formatPhoneDisplay(option)}</span>
    </>
  )

  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value

    if (userSearchTimeout.current) {
      clearTimeout(userSearchTimeout.current)
    }

    userSearchTimeout.current = setTimeout(() => {
      getUsers(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={name}
      label={label}
      placeholder='Cari user dgn email, nama, atau nomor HP'
      dataList={searchUsers}
      onSearchChange={handleSelectSearchOnChange}
      getOptionLabel={getOptionLabel}
      isLoading={isSearchLoading}
      required={required}
      onSelect={(selectedOption) => {
        onSelect(selectedOption)
        setFieldTouched(name, true, false)
      }}
      {...props}
    />
  )
}

UserSelectSearchField.propTypes = propTypes
UserSelectSearchField.defaultProps = defaultProps

export default UserSelectSearchField